<template lang="html">
	<div 
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="main">
    <Hero />
    <Results />
    <Engagement />
    <About />
	</div>
</template>

<script>
import sal from "sal.js"
import Hero from '@/components/partials/Hero'
import About from '@/components/partials/About'
import Results from '@/components/partials/Results'
import Engagement from '@/components/partials/Engagement'

export default {
  mounted() {
    sal();
  },
  components: {
    Hero,
    About,
    Results,
    Engagement
  },
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: min(34vw, 425px);
  @media only screen and (max-width: $screen-phone-max)  {
    padding:0;
  }
  h1 {
    color: black;
    font-size:300px;
  }
}
    
</style>